module.exports = __webpack_public_path__ + "img/icon-white-39.96093636.svg";